import React from 'react';
import {
    MenuItem,
    TextField,
    Grid,
    Chip,
  } from "@mui/material";

function GridDarcyB({handler}, {edificio}) {
  return (
    <div>
        <Grid item xs={3}>
            <TextField
              label="Edifício"
              variant="outlined"
              value={edificio}
              style={{ minWidth: 130, maxWidth: 150 }}
              select
              onChange={handler}
              SelectProps={{
                multiple: false,
                renderValue: (selected) => (
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                      <Chip key={selected} label={selected} style={{ margin: 2 }} />
                  </div>
                ),
              }}
            >
                
                <MenuItem value={'CENTRO OLÍMPICO'}>CENTRO OLÍMPICO</MenuItem>
<MenuItem value={'CEU BL A'}>CEU BL A</MenuItem>
<MenuItem value={'CEU BL B'}>CEU BL B</MenuItem>
<MenuItem value={'FEF'}>FEF</MenuItem>

            </TextField>
          </Grid>

    </div>
  )
}

export default GridDarcyB